<template>
  <div>
    <b-row>
      <b-col sm="6">
        <b-form-group>
          <label for="rol">Código/Descripción</label>
          <b-form-input
            id="search"
            name="search"
            type="text"
            @keypress.enter="searchRoles"
            v-model="filterRoles.search"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col sm="3">
        <b-form-group>
          <label for="estado">Estado</label>
          <el-select
            v-model="filterRoles.state"
            multiple
            :rows="3"
            :max-rows="6"
            name="estado"
            id="estado"
          >
            <el-option
              v-for="estado in estados"
              :key="estado.value"
              :label="estado.text"
              :value="estado.value"
            >
            </el-option>
          </el-select>
        </b-form-group>
      </b-col>
      <b-col sm="3">
        <br />
        <b-form-group class="mt-2">
          <b-button variant="primary" class="ml-2 float-right" @click="createRol(null)">
            <i class="fa fa-plus"></i>
            Crear
          </b-button>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="mb-4">
      <b-col sm="12">
        <b-button-group size="md">
          <b-button variant="primary" @click="searchRoles">
            <i class="fa fa-search fa-lg"></i>
            <span class="d-none d-md-inline-block">Buscar</span>
          </b-button>
          <b-button @click="resetFilters">
            <i class="fa fa-eraser fa-lg"></i>
            <span class="d-none d-md-inline-block"
              >Limpiar</span
            >
          </b-button>
        </b-button-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-table
          responsive
          hover
          bordered
          striped
          thead-class="table-active"
          show-empty
          empty-text="No hay roles para mostrar"
          :items="roles.data"
          :fields="columnas"
        >
          <template v-slot:cell(activo)="data">
            <b-badge
              v-if="data.item.activo"
              variant="primary"
              v-text="'Activo'"
            />
            <b-badge v-else variant="danger" v-text="'Inactivo'"></b-badge>
          </template>
          <template v-slot:cell(opciones)="data">
            <el-tooltip
              effect="dark"
              placement="top"
              content="Copiar"
              popper-class="py-1 px-2"
            >
              <b-button class="btn btn-sm btn-info text-white mx-1" @click="createRol(data.item)">
                <i class="fa fa-copy" variant="primary"></i>
              </b-button>
            </el-tooltip>
            <el-tooltip
              effect="dark"
              placement="top"
              content="Editar"
              popper-class="py-1 px-2"
            >
              <b-button
                class="btn btn-sm btn-primary text-white"
                @click="loadPermissions(data.item)"
              >
                <i class="fa fa-edit" />
              </b-button>
            </el-tooltip>
            <el-tooltip
              effect="dark"
              placement="top"
              :content="data.item.activo ? 'Inactivar' : 'Activar'"
              popper-class="py-1 px-2"
            >
              <b-button
                :class="
                  'btn btn-sm text-white mx-1 ' +
                  (data.item.activo ? 'btn-danger' : 'btn-success')
                "
                @click="changeState(data.item)"
              >
                <i
                  v-if="data.item.activo"
                  class="fa fa-close"
                ></i>
                <i
                  v-else
                  class="fa fa-check text-white"
                ></i>
              </b-button>
            </el-tooltip>
          </template>
        </b-table>
      </b-col>
      <b-col sm="12">
        <el-pagination
          v-model="filterRoles.page"
          @size-change="setPerPage"
          @current-change="setPage"
          :current-page="filterRoles.page"
          :page-sizes="[10, 30, 50, 100]"
          :page-size="filterRoles.perPage"
          :total="roles.total"
          layout="total, sizes, prev, pager, next"
          class="float-right"
        >
        </el-pagination>
      </b-col>
    </b-row>
    <b-modal
      :title="title"
      size="md"
      hide-footer
      @hide="resetSelectedRol"
      ref="modal_rol">  
      <modalRol action="create"></modalRol>
    </b-modal>
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import modalRol from './modalRol.vue';

export default {
  name: "roles",
  data() {
    return {
      title: 'Crear rol',
      estados: [
        {
          value: 0,
          text: "Inactivo",
        },
        {
          value: 1,
          text: "Activo",
        },
      ],
      columnas: [
        {
          key: "codigo",
          label: "Código",
          sortable: true,
          thStyle: {
            width: "200px",
          },
        },
        {
          key: "rol",
          label: "Descripción",
          sortable: true,
        },
        {
          key: "activo",
          label: "Estado",
          sortable: true,
          tdClass: "text-center",
          thStyle: {
            width: "50px",
          },
        },
        {
          key: "opciones",
          label: "Opciones",
          sortable: true,
          thStyle: {
            width: "140px",
          },
        },
      ],
    };
  },
  async created() {
    this.resetSelectedRol();
    this.setPageRoles(1);
    await this.getRoles();
  },
  components: {
    modalRol
  },
  methods: {
    createRol(item) {
      if (item) {
        this.title = 'Crear rol - copia de ' + item.rol.toLowerCase();
        this.setSelectedRol({ acl_roles_id: item.id });
      } else {
        this.title = 'Crear rol';
        this.setSelectedRol({ acl_roles_id: null });
      }
      this.$refs.modal_rol.show();
    },
    async loadPermissions(item) {
      await this.getRolPermissions(item.id);
      this.setSelectedRol(item);
      this.setView(2);
    },
    async changeState(item) {
      const selectedRol = {
        id: item.id,
        acl_roles_id: item.acl_roles_id,
        codigo: item.codigo,
        rol: item.rol,
        activo: item.activo == 1 ? 0 : 1,
      };
      this.setSelectedRol(selectedRol);

      await this.updateRol(item.id);
      await this.getRoles();
      this.resetSelectedRol();
    },
    async setPerPage(perPage) {
      this.setPageRoles(1);
      this.setPerPageRoles(perPage);
      await this.getRoles();
    },
    async setPage(page) {
      this.setPageRoles(page);
      await this.getRoles();
    },
    async searchRoles() {
      this.setPageRoles(1);
      await this.getRoles();
    },
    async resetFilters() {
      this.resetFiltersRoles();
      await this.getRoles();
    },
    editRol() {
      if (this.selectedRol) {
        this.getSelectedRol(this.selectedRol);
      }
    },    
    ...mapMutations("rolesPermissions", [
      "setPageRoles",
      "resetFiltersRoles",
      "setPerPageRoles",
      "setSelectedRol",
      "setView",
      "resetSelectedRol"
    ]),
    ...mapActions("rolesPermissions", [
      "getRoles",
      "getSelectedRol",
      "updateRol",
      "getRolPermissions",
    ]),
  },
  beforeRouteLeave: function(to, from, next) {
    console.log(to);
    next();
  },
  computed: {
    ...mapState("rolesPermissions", ["roles", "filterRoles", "view"]),
  },
};
</script>